import React, { useEffect } from "react";
import Navibar from "../components/Navibar";
import Footer from "../components/Footer";
import baguetteBox from "baguettebox.js"; // Import baguetteBox
import "baguettebox.js/dist/baguetteBox.min.css"; // Import CSS

import Certifications from "../components/Certifications";

export default function Fabrics() {
  // Reusable FabricCard Component
  const FabricCard = ({ imgSrc, altText, description }) => {
    return (
      <div className="col-sm-6 col-md-4 pb-3">
        <a
          className="lightbox wow zoomIn lister bg-dark"
          href={imgSrc}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
            <img
              src={imgSrc}
              alt={altText}
              style={{
                width: "100%",
                height: "inherit",
                maxHeight: "100%",
                objectFit: "fill",
              }}
            />
          </div>
          <p>{description}</p>
        </a>
      </div>
    );
  };

  // Fabric data
  const fabrics = [
    {
      imgSrc: "/img/Products/bath/bath1.png",
      altText: "Bridge",
      description: "Dobby Face Towels",
    },
    {
      imgSrc: "/img/Products/bath/bath2.png",
      altText: "Park",
      description: "Outdoor Towels",
    },
    {
      imgSrc: "/img/Products/bath/bath3.png",
      altText: "Tunnel",
      description: "Bath Curtains",
    },
    {
      imgSrc: "/img/Products/bath/bath4.png",
      altText: "Traffic",
      description: "Satin Bath Robes",
    },
    {
      imgSrc: "/img/Products/bath/bath5.png",
      altText: "Coast",
      description: "Beach Towels",
    },
    {
      imgSrc: "/img/Products/bath/bath6.png",
      altText: "Rails",
      description: "Honeycomb Spa towels",
    },
    {
      imgSrc: "/img/Products/bath/bath7.png",
      altText: "Rails",
      description: "Multipurpose wash towels",
    },
    {
      imgSrc: "/img/Products/bath/bath8.png",
      altText: "Traffic",
      description: "Honeycomb Bath Robes",
    },
    {
      imgSrc: "/img/Products/bath/bath9.png",
      altText: "Coast",
      description: "Muslin Bathrobe",
    },

    {
      imgSrc: "/img/Products/bath/bath11.png",
      altText: "Rails",
      description: "Muslin Face towels",
    },
  ];

  useEffect(() => {
    baguetteBox.run(".tz-gallery");
  }, []); // Run only once after the component mounts

  return (
    <>
      <Navibar />
      <div className="page-title-area">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container">
              <h2>Bath Linen</h2>
              <p>
                "Bath, hand, and face towels are essential bathroom staples that
                combine absorbency and softness for a refreshed feel after every
                wash. Available in a variety of textures and colors, they
                elevate your bathing experience while adding a touch of style to
                your space"
              </p>
              <div className="d-flex justify-content-around">
                <p className="text-bullet">
                  {" "}
                  <li>Yarn Dyed Bath Towels</li>
                  <li>Satin Bath Robes</li>
                </p>
                <p className="text-bullet">
                  <li>Shower Curtains</li>
                  <li>Spa Towels</li>
                </p>
                <p className="text-bullet">
                  <li>Pool Towels</li>
                  <li> Beach Towels</li>
                </p>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tz-gallery">
        <div className="row">
          {fabrics.map((fabric, index) => (
            <FabricCard
              key={index} // Use index but ideally use a unique id
              imgSrc={fabric.imgSrc}
              altText={fabric.altText}
              description={fabric.description}
            />
          ))}
        </div>
      </div>

      <Certifications />
      <Footer />
    </>
  );
}
